'use client'

import type { CSSProperties } from 'react'

interface SliderProps {
  label: string
  value: number
  min: number
  max: number
  step: number
  onChange: (value: number) => void
  suffix?: string
}

/**
 * 自定义 Range Slider（用于 Speed/Pitch/Weirdness/StyleInfluence 等）
 * 轨道颜色与 thumb 样式由 .voice-app input[type='range'] 控制（见 voice.css）
 */
export const Slider = ({ label, value, min, max, step, onChange, suffix = '' }: SliderProps) => {
  const pct = ((value - min) / (max - min)) * 100

  return (
    <div>
      <div className="mb-1 flex justify-between text-[11px] text-[var(--text-3)]">
        <span>{label}</span>
        <span className="voice-mono text-[var(--text-1)]">
          {value}
          {suffix}
        </span>
      </div>
      <input
        max={max}
        min={min}
        step={step}
        style={{ '--val': `${pct}%` } as CSSProperties}
        type="range"
        value={value}
        onChange={e => onChange(parseFloat(e.target.value))}
      />
    </div>
  )
}
